export const tasksKeys = {
    task: ["task"] as const,
    addRecommendedTask: ()=> [...tasksKeys.task, "create"] as const,
    getTasksByEncounterId: (id: string) => [...tasksKeys.task, id] as const,
    deleteTask: (id: string) => [...tasksKeys.task, "delete", id] as const,
}